<template>
  <img
    src="https://static.wangsu.com/lib/images/status/v1/expiration.min.svg"
    alt="expiration"
  />
</template>
<script setup lang="ts">
import { defineComponent } from 'vue'

defineComponent({
  name: 'ElResultIconExpiration',
})
</script>
